export default __webpack_public_path__ + "step-backward.png";